import React from 'react';

function About() {
  return (
    <div>
      <h1>About Frum Referrals</h1>
      <p>Frum Referrals is a platform dedicated to connecting the Jewish community with trusted service providers and resources.</p>
    </div>
  );
}

export default About; 